import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import API from '../shared/forms/API';
import LoadingView from '../shared/LoadingView';
import { CHANNEL_LABELS } from './fieldDefinitions';

export default class NotificationConfigPageView extends Component {
  state = { catalog: null };

  componentDidMount() {
    new API()
      .fetch('settings/notification-catalog')
      .then((response) => {
        if (response.ok) return response.json();
        throw new Error(response.statusText);
      })
      .then((catalog) => Array.isArray(catalog) && this.setState({ catalog }))
      .catch((error) => console.error(error));
  }

  renderRow = (item) => (
    <tr
      key={item.slug}
      style={{ cursor: 'pointer' }}
      onClick={() => this.props.history.push(`/notification-config/${item.slug}/`)}
    >
      <td title={item.description}>
        {item.name}
      </td>
      <td>{CHANNEL_LABELS[item.channel]}</td>
      <td className="text-center">
        {item.defaultConfigured ? (
          <i className="fa fa-check text-success"></i>
        ) : (
          <i className="fa fa-times text-danger"></i>
        )}
      </td>
      <td>
        {(() => {
          const locs = item.locationOverrides;
          const MAX = 6;
          const visible = locs.slice(0, MAX);
          const rest = locs.length - MAX;
          return (
            <>
              {visible.map((loc) => (
                <React.Fragment key={loc}>
                  <Link
                    to={`/notification-config/${item.slug}/edit/${encodeURIComponent(loc)}/`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {loc}
                  </Link>{' '}
                </React.Fragment>
              ))}
              {rest > 0 && (
                <Link
                  to={`/notification-config/${item.slug}/`}
                  className="text-muted"
                  onClick={(e) => e.stopPropagation()}
                >
                  +{rest} meer
                </Link>
              )}
            </>
          );
        })()}
      </td>
    </tr>
  );

  renderContent() {
    const { catalog } = this.state;

    if (catalog.length === 0) {
      return null;
    }

    return (
      <>
        <table className="table table-hover mb-0">
          <thead>
            <tr>
              <th>Notificatie</th>
              <th>Type</th>
              <th className="text-center">Standaard</th>
              <th>Locatie afhankelijk</th>
            </tr>
          </thead>
          <tbody>{catalog.map(this.renderRow)}</tbody>
        </table>
      </>);
  }

  render() {
    return (
      <div>
        <nav className="navbar navbar-expand navbar-light bg-light">
          <div className="navbar-brand">Notificatie templates</div>
        </nav>
        <div className="container-fluid my-4">
          {this.state.catalog === null ? <LoadingView /> : this.renderContent()}
        </div>
      </div>
    );
  }
}
